import { GridElementDecoratorContent } from './GridElementDecoratorContent';
import {
    defaultGridElementDecoratorResource,
    useGridElementDecoratorActions,
    GridElementDecoratorMutationResourceSchema,
    GridElementDecoratorResource,
} from '../../../../resource/resources/artifacts/use_case/representation/gridElementDecoratorResource';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { creationDialogOnSuccess } from '../../../util/utilFunctions';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import React from 'react';
import {
    Form_DisplayComponentBaseView,
} from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';

export const GridElementDecoratorCreationDialog= ({ onClose, parentId, autoGeneratedProps, onCreated }: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: GridElementDecoratorResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const gridElementDecoratorActions = useGridElementDecoratorActions()
    const addGridElementDecorator = gridElementDecoratorActions.useSetResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: GridElementDecoratorMutationResourceSchema,
        defaultValues: {
            ...defaultGridElementDecoratorResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addGridElementDecorator.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Grid Element Decorator'}
            resourceType={ResourceType.GRID_ELEMENT_DECORATOR}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <GridElementDecoratorContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};